import Cookies from 'universal-cookie';

const cookies = new Cookies();

export const getToken = (): string => cookies.get('@sch/token');

export const setToken = (token: string) => {
  cookies.set('@sch/token', token, { path: '/' });
};

export const removeToken = () => cookies.remove('@sch/token', { path: '/' });
